import { render, staticRenderFns } from "./Teknoted_addGame.vue?vue&type=template&id=6c1bb09a"
import script from "./Teknoted_addGame.vue?vue&type=script&lang=js"
export * from "./Teknoted_addGame.vue?vue&type=script&lang=js"
import style0 from "./Teknoted_addGame.vue?vue&type=style&index=0&id=6c1bb09a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports